/**
 * BAŞARILI BİR YAZMA DUYURULUR (1 Kasım 2026, kullanıcı: «herhangi bir işlemden sonra sayfaya her girilince
 * hangi sayfa olursa olsun refreshlesin datayı»).
 *
 * İstemci (`client.ts › request`) başarılı her yazmanın (POST, PUT, PATCH, DELETE) cevabı okununca burayı
 * çağırıyor; dinleyen tek şey uygulamanın sorgu istemcisi (`query-client.ts › staleAfterWrite`): önbellekteki
 * her şeyi bayat sayıyor, açık ekranın sorgularını yeniden çekiyor, öbürleri girilince çekiliyor.
 *
 * AYRI MODÜL, çünkü sınamaların çoğu `@/lib/api/client`'ı bir fabrikayla sahteliyor ve fabrikada bu işlev
 * yok — sorgu istemcisi onu `client.ts`'ten alsaydı o sınamalar içe aktarmada düşerdi
 * (`request-signal.ts` aynı sebeple ayrı).
 */
const listeners = new Set<() => void>();

/** Başarılı her (sessiz olmayan) yazmadan sonra çağrılır; dönen işlev aboneliği kaldırır. */
export function onWriteSucceeded(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** İstemcinin çağırdığı yarı: bir yazma bitti ve önbellekteki cevaplar artık eskimiş olabilir. */
export function announceWrite(): void {
  for (const listener of listeners) listener();
}
